import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Home, Login, Register } from './pages'
import { AuthContextProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components';
import { ChatContextProvider } from './contexts/ChatContext';
import { NavContextProvider } from './contexts/NavContext';

const App = () => {
  return (
    <AuthContextProvider>
      <ChatContextProvider>
        <NavContextProvider>
          <div className="md:bg-gray-100 min-h-screen">
            <Router>
              <Routes>
                <Route path='/' element={<ProtectedRoute>
                  <Home /></ProtectedRoute>} />
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
              </Routes>
            </Router>
          </div>
        </NavContextProvider>
      </ChatContextProvider>
    </AuthContextProvider>
  );
}

export default App;